<template>
  <div class="d-flex gap-8 flex-wrap">
    <div>
      <BaseCard title="Use locations in project" width="500" max-width="90vw">
        <div>
          <BaseInput
            type="switch"
            :disabled="!edit"
            v-model="use_locations"
          />
        </div>
      </BaseCard>
    </div>
    <BaseCard title="Locations" v-if="use_locations" class="flex-grow-1" min-width="50vw">
      <div>
        <div v-for="(item, i) in locations" :key="i" class="d-flex gap-2 align-center py-1 px-2" :class="{'grey': i % 2}">
          <BaseInput
            v-if="temp_location?.id === item.id"
            class="flex-grow-1 ml-n2"
            v-model="temp_location.name"
          />
          <div v-else class="flex-grow-1">
            {{ item.name }}
          </div>
          <template v-if="edit">
            <template v-if="temp_location?.id === item.id">
              <v-btn icon small color="primary" @click="saveItem(i)">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn icon small class="mr-n1" color="red" @click="temp_location = null">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <BaseButton
                icon_only
                default_icon="button-edit"
                minimalize
                @click="editItem(i)"
              />
              <DeleteModal
                :text="item.name"
                :key="item.name"
                :method-delete="deleteItem"
                :additional-info="i"
              />
            </template>
          </template>
        </div>
        <div v-if="temp_location && !temp_location.id" class="d-flex gap-2 align-center">
          <BaseInput
            v-model="temp_location.name"
            class="flex-grow-1"
          />
          <template v-if="edit">
            <BaseButton
              icon_only
              default_icon="button-save"
              :icon-height="20"
              :icon-width="20"
              minimalize
              @click="saveLocation(temp_location, null)"
            />
            <DeleteModal
              :text="temp_location.name"
              :method-delete="deleteTemp"
              :key="temp_location.name"
            />
          </template>
        </div>
      </div>
      <BaseButton
        v-if="edit"
        @click="addItem"
        :text="localStorage.translations.pages.common['buttons']['dobavit']"
        default_icon="button-add"
        :disabled="temp_location && !temp_location.id"
      />
    </BaseCard>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import BaseCard from "components/base/BaseCard.vue";
import BaseInput from "components/base/BaseInput.vue";
import BaseButton from "components/base/BaseButton.vue";
import DeleteBtn from "components/DeleteBtn.vue";
import DeleteModal from "components/DeleteModal.vue";

export default defineComponent({
  name: "ProjectLocations",
  components: {DeleteModal, DeleteBtn, BaseButton, BaseInput, BaseCard},
  props: {
    edit: Boolean,
  },
  data: () => ({
    use_locations: true,
    locations: [
      {id: '2135', name: 'House 1, floor 2, aparment 4'},
      {id: '2136', name: 'Block A'},
      {id: '2137', name: 'Block B'},
      {id: '2138', name: 'Block C'},
    ],
    temp_location: null,
  }),
  methods: {
    addItem() {
      this.temp_location = {name: ''}
    },
    deleteTemp() {
      this.temp_location = null
    },
    saveLocation(item, pos) {
      if (pos) {

      } else {
        this.temp_location.id = this.locations.length
        this.locations.push(this.temp_location)
        this.temp_location = null
      }
    },
    deleteItem(pos) {
      this.locations.splice(pos,1)
      return null
    },
    editItem(pos) {
      this.temp_location = Object.assign({}, this.locations[pos])
    },
    saveItem(pos) {
      this.locations[pos].name = this.temp_location.name
      this.temp_location = null
    }
  }
})
</script>

<style scoped lang="scss">
:deep().v-input.v-input--is-disabled .v-input__control .v-input__slot {
  background: none !important;
}
.grey {
  background-color: rgba(122, 137, 153, 0.05) !important;
}
</style>